export default __webpack_public_path__ + "static/media/fasting_sleep@2x.2d0434cd.jpg";